{
	"ApplyNow": {
		"Question 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Please enter your full name"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your Name"
				},
				"label": {
					"translations": {},
					"value": "Name"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Email Address must be valid \".edu\" required for college applicants"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter a valid email address"
				},
				"label": {
					"translations": {},
					"value": "Email Address"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "email"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Please enter a phone number you can be reached at"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please Enter a valid phone number"
				},
				"label": {
					"translations": {},
					"value": "Phone"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "phone"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Please enter your full mailing address below"
				},
				"label": {
					"translations": {},
					"value": "Mailing Address"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "textarea"
				}
			}
		},
		"Question 04a": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Mailing Address"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your Street Address"
				},
				"label": {
					"translations": {},
					"value": "Street Address"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04b": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"label": {
					"translations": {},
					"value": "Street Address Line 2"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04c": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your City"
				},
				"label": {
					"translations": {},
					"value": "City"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04d": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your State / Province"
				},
				"label": {
					"translations": {},
					"value": "State / Province"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04e": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your Postal / Zip Code"
				},
				"label": {
					"translations": {},
					"value": "Postal / Zip Code"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter you date of birth"
				},
				"label": {
					"translations": {},
					"value": "Date of Birth"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "date"
				}
			}
		},
		"Question 11": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Please choose from one of the scholarships listed"
				},
				"invalidMessage": {
					"translations": {},
					"value": "You must choose one of the listed scholarships"
				},
				"label": {
					"translations": {},
					"value": "Scholarship Selection"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "High School Scholarship+||+College / Junior College / Graduate Scholarship"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "radio"
				}
			}
		},
		"Question 12": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "What Current School are you attending?"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your current school name"
				},
				"label": {
					"translations": {},
					"value": "Current School"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 13": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "What is your current student status or year?"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please select your current grade level or year"
				},
				"label": {
					"translations": {},
					"value": "Student Status / Year"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "High School Senior+||+College Freshman+||+College Sophomore+||+College Junior+||+College Senior accepted/enrolled in graduate school+||+Graduate Student - Not in final year"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "radio"
				}
			}
		},
		"Question 14": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "What is your current cumulative GPA?"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your current cumulative GPA"
				},
				"label": {
					"translations": {},
					"value": "Cumulative GPA"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 15": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "image/*+||+application/pdf"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Transcript (file upload — PDF or image of official/unofficial transcript)"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please drop your transcript file or files here"
				},
				"label": {
					"translations": {},
					"value": "Transcript Uploads"
				},
				"requiredCount": {
					"translations": {},
					"value": "1"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Question 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "application/pdf+||+application/msword+||+application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### High School Essay Prompt\n**\"Describe a time you or someone you know was given a second chance. What did you learn from it?\"**\n\nYour essay must be:\n - A minimum of 1,000 words\n - Original, clearly written, and well-organized\n - Thoughtful, creative, and grammatically sound\n\nEssays will be scored based on clarity, depth, organization, and connection to the theme.\n\nYou can upload your essay by dropping it below or submit it at a later time (file upload — PDF or Word)"
				},
				"hideInForm": {
					"translations": {},
					"value": "Scholarship Selection+|+not-in+|+High School Scholarship"
				},
				"label": {
					"translations": {},
					"value": "High School Essay Upload"
				},
				"requiredCount": {
					"translations": {},
					"value": "0"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Question 22": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "application/pdf+||+application/msword+||+application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### College Essay Prompt\n**“What does justice mean in today’s society, and how do you believe the criminal justice system can better serve the people it protects?”**\n\nYour essay must be:\n - A minimum of 1,000 words\n - Original, clearly written, and well-organized\n - Thoughtful, creative, and grammatically sound\n\nEssays will be scored based on clarity, depth, organization, and connection to the theme.\n\nYou can upload your essay by dropping it below or submit it at a later time (file upload — PDF or Word)"
				},
				"hideInForm": {
					"translations": {},
					"value": "Scholarship Selection+|+not-in+|+College / Junior College / Graduate Scholarship"
				},
				"label": {
					"translations": {},
					"value": "College Essay Upload"
				},
				"requiredCount": {
					"translations": {},
					"value": "0"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Question 41": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### Please confirm you meet the following eligibility requirements for your selected scholarship."
				},
				"invalidMessage": {
					"translations": {},
					"value": "You must confirm you meet the requirements by checking each box"
				},
				"label": {
					"translations": {},
					"value": "Eligibility Checklist"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "I am a U.S. citizen or lawful permanent resident.+||+I meet the GPA requirement (3.0 or higher).+||+I am enrolled full-time in high school (senior year) OR in college (freshman–junior).+||+I am not an employee of Sevens Legal Criminal Lawyers, nor an immediate family/household member of one."
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"requiredCount": {
					"translations": {},
					"value": "4"
				},
				"type": {
					"translations": {},
					"value": "checkbox"
				}
			}
		},
		"Question 42": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### Please agree to the following terms listed below."
				},
				"invalidMessage": {
					"translations": {},
					"value": "You must agree to the terms listed by checking each box"
				},
				"label": {
					"translations": {},
					"value": "Consent & Agreement"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "I agree to the Terms & Legal Disclosures of the scholarship program.+||+I grant Sevens Legal Criminal Lawyers permission to use my name, likeness, and submitted materials in promotional content if selected.+||+I acknowledge that the information I’ve provided is true and accurate to the best of my knowledge."
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"requiredCount": {
					"translations": {},
					"value": "3"
				},
				"type": {
					"translations": {},
					"value": "checkbox"
				}
			}
		},
		"Question 43": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "image/*"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### Profile Photo Upload (Optional)\nIf you wish at this time, you may upload a photo of yourself."
				},
				"label": {
					"translations": {},
					"value": "Photo Upload"
				},
				"requiredCount": {
					"translations": {},
					"value": "0"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Section 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Please provide your personal contact details so we can reach you if needed. This includes your full name, email address, phone number, mailing address, and date of birth."
				},
				"label": {
					"translations": {},
					"value": "Applicant Information"
				},
				"questions": {
					"translations": {},
					"value": "Question 01+||+Question 02+||+Question 03+||+Question 04a+||+Question 04b+||+Question 04c+||+Question 04d+||+Question 04e+||+Question 05"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"Section 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Tell us about your academic background. Select the scholarship you’re applying for, share your current school, grade level or year, GPA, and (optionally) upload your transcript.\n\n<br />\n\n*Don’t worry if you don’t have your transcript ready — you can still apply today.*"
				},
				"label": {
					"translations": {},
					"value": "Academic Information"
				},
				"questions": {
					"translations": {},
					"value": "Question 11+||+Question 12+||+Question 13+||+Question 14+||+Question 15"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"Section 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Every scholarship includes an essay prompt. We’d love to see your essay now, but you can also apply without it and submit later."
				},
				"label": {
					"translations": {},
					"value": "Essay Submission"
				},
				"questions": {
					"translations": {},
					"value": "Question 21+||+Question 22"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"Section 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Before submitting, please confirm that you meet the eligibility criteria and agree to the terms of this scholarship program. You may also upload an optional photo if you’d like to include one."
				},
				"label": {
					"translations": {},
					"value": "Eligibility, Consent & Agreement"
				},
				"questions": {
					"translations": {},
					"value": "Question 41+||+Question 42+||+Question 43"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"general": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"confirmationMessage": {
					"translations": {},
					"value": "### Thank you for your application!  It has been submitted successfully.\n\n<br />\n\n*If you are using a public computer, use the reset button to the right to clear you data from the browser*"
				},
				"formName": {
					"translations": {},
					"value": "Scholarships"
				},
				"title": {
					"translations": {},
					"value": "Scholarship Application"
				}
			}
		},
		"index": 0
	},
	"Features 01": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "### Four scholarships are available for both high school & college students"
				},
				"title": {
					"translations": {},
					"value": "What"
				}
			}
		},
		"Feature 01 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"circle-question\",\"icon\":[512,512,[62108,\"question-circle\"],\"f059\",\"M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zm0-336c-17.7 0-32 14.3-32 32 0 13.3-10.7 24-24 24s-24-10.7-24-24c0-44.2 35.8-80 80-80s80 35.8 80 80c0 47.2-36 67.2-56 74.5l0 3.8c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-8.1c0-20.5 14.8-35.2 30.1-40.2 6.4-2.1 13.2-5.5 18.2-10.3 4.3-4.2 7.7-10 7.7-19.6 0-17.7-14.3-32-32-32zM224 368a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z\"]}",
				"name": "faCircleQuestion"
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "### Submit a 1,000-word essay & school transcript"
					},
					"value": "### Submit a 1,000-word essay & school transcript"
				},
				"title": {
					"translations": {
						"en": "How"
					},
					"value": "How"
				}
			}
		},
		"Feature 02 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"person-chalkboard\",\"icon\":[640,512,[],\"e53d\",\"M192 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112zM176 512l0-160c0-8.8 7.2-16 16-16s16 7.2 16 16l0 160c0 17.7 14.3 32 32 32s32-14.3 32-32l0-336 128 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-16 0 0-48 192 0 0 192-192 0 0-32-64 0 0 48c0 26.5 21.5 48 48 48l224 0c26.5 0 48-21.5 48-48l0-224c0-26.5-21.5-48-48-48L368 0c-26.5 0-48 21.5-48 48l0 64-122.7 0c-45.6 0-88.5 21.6-115.6 58.2L14.3 260.9c-10.5 14.2-7.6 34.2 6.6 44.8s34.2 7.6 44.8-6.6L112 236.7 112 512c0 17.7 14.3 32 32 32s32-14.3 32-32z\"]}",
				"name": "faPersonChalkboard"
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "### Friday, December 18, 2026 @ 11:59 PM PST"
					},
					"value": "### Friday, December 18, 2026 @ 11:59 PM PST"
				},
				"title": {
					"translations": {
						"en": "When"
					},
					"value": "When"
				}
			}
		},
		"Feature 03 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"clock\",\"icon\":[512,512,[128339,\"clock-four\"],\"f017\",\"M256 0a256 256 0 1 1 0 512 256 256 0 1 1 0-512zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z\"]}",
				"name": "faClock"
			}
		},
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "At Sevens Legal Criminal Lawyers, we are committed to supporting students who are actively shaping their future through hard work, resilience, and a commitment to learning. As a San Diego-based criminal defense firm, we’ve spent decades advocating for individuals and standing up for what’s fair—and we see education as a powerful tool for creating lasting impact.\n\n**We are proud to offer two scholarships to support high school and college students in pursuing their educational goals!**\n\nIf you’re ready to take the next step in your academic journey, we encourage you to apply."
				},
				"href": {
					"translations": {},
					"value": "/#apply-now-form"
				},
				"label": {
					"translations": {},
					"value": "Apply Now"
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "hover-ripple btn sm:btn-xl mt-2 sm:mt-4 shadow-lg whitespace-nowrap flex items-center justify-center btn-primary mx-auto"
				},
				"contentClass": {
					"translations": {},
					"value": "mx-2 sm:mx-4 my-0 py-24"
				},
				"featureClass": {
					"translations": {},
					"value": "bg-base-300 rounded-xl p-3 sm:p-4 text-center min-h-72 shadow-xl"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "w-full m-auto text-center max-w-96"
				},
				"featureTitleContainerClass": {
					"translations": {},
					"value": "w-full text-center"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap justify-evenly gap-2 sm:gap-4 py-2 sm:py-4"
				},
				"iconClass": {
					"translations": {},
					"value": "text-color my-2 sm:my-4 mx-auto"
				}
			}
		},
		"index": 1,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "2"
			},
			"type": "TextInput",
			"value": "2"
		}
	},
	"Features 02": {
		"Feature 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "The deadline to apply is Friday, December 18, 2026 @ 11:59 PM PST"
					},
					"value": "The deadline to apply is Friday, December 18, 2026 @ 11:59 PM PST"
				},
				"title": {
					"translations": {
						"en": "Deadline to Apply"
					},
					"value": "Deadline to Apply"
				}
			}
		},
		"Feature 01 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"calendar-days\",\"icon\":[448,512,[\"calendar-alt\"],\"f073\",\"M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 32 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l32 0 0-32c0-17.7 14.3-32 32-32zM64 240l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 368l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z\"]}",
				"name": "faCalendarAlt"
			}
		},
		"Feature 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "- Complete the online submission form\n - Upload your essay (PDF or Word format)\n - Provide your full name, contact information, and a valid email address (college applicants must use a university-issued .edu email address)\n\n**Note:** *Only one entry per student will be considered.*"
					},
					"value": "- Complete the online submission form\n - Upload your essay (PDF or Word format)\n - Provide your full name, contact information, and a valid email address (college applicants must use a university-issued .edu email address)\n\n**Note:** *Only one entry per student will be considered.*"
				},
				"title": {
					"translations": {
						"en": "How To Apply"
					},
					"value": "How To Apply"
				}
			}
		},
		"Feature 02 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"clipboard-check\",\"icon\":[384,512,[],\"f46c\",\"M256 0c23.7 0 44.4 12.9 55.4 32l8.6 0c35.3 0 64 28.7 64 64l0 352c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 96C0 60.7 28.7 32 64 32l8.6 0C83.6 12.9 104.3 0 128 0L256 0zm26.9 212.6c-10.7-7.8-25.7-5.4-33.5 5.3l-85.6 117.7-26.5-27.4c-9.2-9.5-24.4-9.8-33.9-.6s-9.8 24.4-.6 33.9l46.4 48c4.9 5.1 11.8 7.8 18.9 7.3s13.6-4.1 17.8-9.8L288.2 246.1c7.8-10.7 5.4-25.7-5.3-33.5zM136 64c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L136 64z\"]}",
				"name": "faClipboardCheck"
			}
		},
		"Feature 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {
						"en": "Scholarship recipients will be selected by a panel of judges based on the creativity, relevance, and overall quality of their essays. Winners will be notified via email or mail within 30 days of the application deadline and must confirm acceptance of the award within 14 days of notification. If a winner does not respond within that timeframe or is found to be ineligible, an alternate recipient may be selected at the discretion of the scholarship panel."
					},
					"value": "Scholarship recipients will be selected by a panel of judges based on the creativity, relevance, and overall quality of their essays. Winners will be notified via email or mail within 30 days of the application deadline and must confirm acceptance of the award within 14 days of notification. If a winner does not respond within that timeframe or is found to be ineligible, an alternate recipient may be selected at the discretion of the scholarship panel."
				},
				"title": {
					"translations": {
						"en": "Winner Announcement"
					},
					"value": "Winner Announcement"
				}
			}
		},
		"Feature 03 Icon": {
			"permission": "Admin",
			"type": "Icon",
			"value": {
				"icon": "{\"prefix\":\"fas\",\"iconName\":\"ribbon\",\"icon\":[384,512,[127895],\"f4d6\",\"M235.1 0c33.4 0 64.5 17.4 81.9 45.9 1.2 2 13 21.3 35.3 57.8 21.1 34.5 18.3 78.5-7 110L278.3 297.7 364.5 406c5.5 6.9 4.4 16.9-2.5 22.5l-80 64c-6.9 5.5-17 4.4-22.5-2.5L38.6 213.8C13.3 182.3 10.5 138.3 31.6 103.8 54 67.2 65.7 47.9 67 45.9 84.4 17.4 115.4 0 148.9 0l86.3 0zM192 189.2l48.6-61.2-97.3 0 48.6 61.2zM75 336.2l86.2 107.8-36.8 46c-5.5 6.9-15.6 8-22.5 2.5l-80-64c-6.9-5.5-8-15.6-2.5-22.5L75 336.2z\"]}",
				"name": "faRibbon"
			}
		},
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"description": {
					"translations": {},
					"value": "## Questions?\n\nWe’re here to help.\nReach out to jessica@sevenslegal.com with any scholarship inquiries."
				}
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "mx-2 sm:mx-4 my-0 py-24"
				},
				"featureClass": {
					"translations": {},
					"value": "bg-base-300 rounded-xl p-3 sm:p-4 text-left min-h-[500px] shadow-xl"
				},
				"featureContainerClass": {
					"translations": {},
					"value": "w-full m-auto text-center max-w-96"
				},
				"featureTitleContainerClass": {
					"translations": {},
					"value": "w-full text-center my-2 sm:my-4"
				},
				"featuresContainerClass": {
					"translations": {},
					"value": "flex flex-wrap justify-evenly gap-2 sm:gap-4 py-2 sm:py-4"
				},
				"iconClass": {
					"translations": {},
					"value": "text-color my-2 sm:my-4 mx-auto"
				}
			}
		},
		"index": 2,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "5"
			},
			"type": "TextInput",
			"value": "5"
		}
	},
	"Features 03": {
		"bgAltBase": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"en": "### Terms & Legal Disclosures"
			},
			"type": "TextInput",
			"value": "### Terms of Service – Sevens Legal Criminal Lawyers Scholarship Program"
		},
		"index": 3,
		"markedContent": {
			"permission": "Admin",
			"translations": {
				"en": "**Effective Date**: The date of application\n\nThese Terms of Service (“Terms”) govern participation in the **Sevens Legal Criminal Lawyers Scholarship Program** (the “Program”). By submitting an application, you (“Applicant”) agree to these Terms.\n\n### 1. Eligibility\n - Applicants must meet all eligibility requirements outlined in the scholarship application.\n - Proof of eligibility (including, but not limited to, transcripts, GPA verification, enrollment verification, or other requested materials) must be provided upon request if selected as a winner.\n - Applicants who fail to provide requested documentation may be disqualified.\n\n### 2. Submissions\n - All application materials, including essays, statements, videos, or other content (“Submissions”), must be the Applicant’s original work.\n - By applying, the Applicant grants **Sevens Legal Criminal Lawyers** a **perpetual, royalty-free, worldwide, non-exclusive license** to use, reproduce, distribute, publish, and display the Submissions, in whole or in part, for promotional, educational, and marketing purposes.\n\n### 3. Name, Image, and Likeness\n - By submitting an application, Applicants grant **Sevens Legal Criminal Lawyers** permission to use their **name, image, likeness, voice, testimonial statement, and biographical information** in connection with the Program.\n - This includes, but is not limited to, use in **press releases, promotional campaigns, social media posts, website features, printed materials, and future scholarship announcements**.\n - Scholarship recipients agree to: \n   - Provide a **short written statement** or testimonial about how the scholarship impacted them, which **may be quoted publicly**.\n   - Have their **photograph taken with representatives of Sevens Legal Criminal Lawyers** and grant permission for that photo to be used in promotional materials, social media, press releases, and on the Sevens Legal website, without additional compensation.\n\n### 4. Selection and Awards\n - Scholarship recipients will be selected based on the criteria outlined in the application.\n - Decisions of the scholarship selection committee are **final and binding**.\n - Awards are non-transferable and may be subject to federal, state, or local tax reporting. Applicants are solely responsible for any applicable taxes.\n\n### 5. Verification of Winners\n - Potential winners must provide requested documentation within the time frame specified by **Sevens Legal Criminal Lawyers**. This may include:\n   - Government-issued photo identification,\n   - Official or unofficial transcripts,\n   - Verification of GPA and/or enrollment.\n - Failure to provide verification may result in forfeiture of the award and the selection of an alternate recipient.\n\n### 6. Code of Conduct\n - Applicants may not submit false, misleading, plagiarized, or fraudulent information.\n - Any misconduct or violation of these Terms may result in disqualification, forfeiture of the award, and potential exclusion from future programs.\n\n### 7. Limitation of Liability\n**Sevens Legal Criminal Lawyers** is not responsible for:\n - Lost, late, incomplete, or misdirected applications,\n - Technical malfunctions or failures of any kind,\n - Any injury, loss, or damage resulting from participation in the Program or use of the scholarship award.\n\n### 8. Privacy\n - Information collected through the application process will be used solely for the purpose of administering the Program, unless otherwise stated in these Terms.\n - Limited information (such as the award recipient’s name, school, photograph, and testimonial) may be made public as part of promotional activities.\n\n### 9. Modifications\n**Sevens Legal Criminal Lawyers** reserves the right to **modify, suspend, or terminate** the Program at any time, with or without notice, at its sole discretion.\n\n### 10. Governing Law\n - These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law principles."
			},
			"type": "TextArea",
			"value": "**Effective Date**: The date of application\n\nThese Terms of Service (“Terms”) govern participation in the **Sevens Legal Criminal Lawyers Scholarship Program** (the “Program”). By submitting an application, you (“Applicant”) agree to these Terms.\n\n### 1. Eligibility\n - Applicants must meet all eligibility requirements outlined in the scholarship application.\n - Proof of eligibility (including, but not limited to, transcripts, GPA verification, enrollment verification, or other requested materials) must be provided upon request if selected as a winner.\n - Applicants who fail to provide requested documentation may be disqualified.\n\n### 2. Submissions\n - All application materials, including essays, statements, videos, or other content (“Submissions”), must be the Applicant’s original work.\n - By applying, the Applicant grants **Sevens Legal Criminal Lawyers** a **perpetual, royalty-free, worldwide, non-exclusive license** to use, reproduce, distribute, publish, and display the Submissions, in whole or in part, for promotional, educational, and marketing purposes.\n\n### 3. Name, Image, and Likeness\n - By submitting an application, Applicants grant **Sevens Legal Criminal Lawyers** permission to use their **name, image, likeness, voice, testimonial statement, and biographical information** in connection with the Program.\n - This includes, but is not limited to, use in **press releases, promotional campaigns, social media posts, website features, printed materials, and future scholarship announcements**.\n - Scholarship recipients agree to: \n   - Provide a **short written statement** or testimonial about how the scholarship impacted them, which **may be quoted publicly**.\n   - Have their **photograph taken with representatives of Sevens Legal Criminal Lawyers** and grant permission for that photo to be used in promotional materials, social media, press releases, and on the Sevens Legal website, without additional compensation.\n\n### 4. Selection and Awards\n - Scholarship recipients will be selected based on the criteria outlined in the application.\n - Decisions of the scholarship selection committee are **final and binding**.\n - Awards are non-transferable and may be subject to federal, state, or local tax reporting. Applicants are solely responsible for any applicable taxes.\n\n### 5. Verification of Winners\n - Potential winners must provide requested documentation within the time frame specified by **Sevens Legal Criminal Lawyers**. This may include:\n   - Government-issued photo identification,\n   - Official or unofficial transcripts,\n   - Verification of GPA and/or enrollment.\n - Failure to provide verification may result in forfeiture of the award and the selection of an alternate recipient.\n\n### 6. Code of Conduct\n - Applicants may not submit false, misleading, plagiarized, or fraudulent information.\n - Any misconduct or violation of these Terms may result in disqualification, forfeiture of the award, and potential exclusion from future programs.\n\n### 7. Limitation of Liability\n**Sevens Legal Criminal Lawyers** is not responsible for:\n - Lost, late, incomplete, or misdirected applications,\n - Technical malfunctions or failures of any kind,\n - Any injury, loss, or damage resulting from participation in the Program or use of the scholarship award.\n\n### 8. Privacy\n - Information collected through the application process will be used solely for the purpose of administering the Program, unless otherwise stated in these Terms.\n - Limited information (such as the award recipient’s name, school, photograph, and testimonial) may be made public as part of promotional activities.\n\n### 9. Modifications\n**Sevens Legal Criminal Lawyers** reserves the right to **modify, suspend, or terminate** the Program at any time, with or without notice, at its sole discretion.\n\n### 10. Governing Law\n - These Terms shall be governed by and construed in accordance with the laws of the State of California, without regard to its conflict of law principles."
		},
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "7"
			},
			"type": "TextInput",
			"value": "7"
		}
	},
	"Features 03 - HOLD": {
		"description": {
			"permission": "Admin",
			"translations": {
				"en": "### Terms & Legal Disclosures"
			},
			"type": "TextInput",
			"value": "### Terms & Legal Disclosures"
		},
		"flipped": {
			"permission": "Admin",
			"translations": {
				"en": "true"
			},
			"type": "TextInput",
			"value": "true"
		},
		"index": 4,
		"markedContent": {
			"permission": "Admin",
			"translations": {
				"en": "The promoter of this scholarship is Sevens Legal Criminal Lawyers, located at 3555 Fourth Ave., San Diego, CA 92103.\n\nThis scholarship is:\n - Void where prohibited by law\n - Free to enter (no purchase necessary). Making a purchase or payment will not increase the chances of winning\n - Open to U.S. citizens and lawful permanent residents only\n - Non-transferable and not redeemable for cash\n\n**Participant Responsibilities & Consent**\n\nBy submitting an application, the applicant agrees to all official Terms and Conditions of the scholarship. The applicant also grants Sevens Legal Criminal Lawyers permission to use their name, likeness, and submitted materials in promotional content, unless prohibited by law. Selected recipients are responsible for keeping Sevens Legal Criminal Lawyers informed of any changes to their contact information during the scholarship period\n\n**Right to Modify or Cancel**\n\nSevens Legal Criminal Lawyers reserves the right to cancel, suspend, or modify the scholarship or these terms in the event of force majeure or other circumstances beyond its control. Any changes will be posted on the official scholarship webpage.\n\n**Third-Party Responsibility Disclaimer**\n\nSevens Legal Criminal Lawyers is not responsible for inaccurate prize details provided by third parties connected to this promotion.\n\n**Governing Law and Jurisdiction**\n\nThis promotion is governed by the laws of the State of California. Any disputes will be subject to the exclusive jurisdiction of the courts located in the State of California.\n\n**Social Media Disclaimer**\n\nThis promotion is in no way sponsored, endorsed, or administered by, or associated with, Facebook, Twitter, Instagram, or any other platform. Information provided is solely for use by Sevens Legal Criminal Lawyers and will be handled according to our Privacy Policy."
			},
			"type": "TextArea",
			"value": "The promoter of this scholarship is Sevens Legal Criminal Lawyers, located at 3555 Fourth Ave., San Diego, CA 92103.\n\nThis scholarship is:\n - Void where prohibited by law\n - Free to enter (no purchase necessary). Making a purchase or payment will not increase the chances of winning\n - Open to U.S. citizens and lawful permanent residents only\n - Non-transferable and not redeemable for cash\n\n**Participant Responsibilities & Consent**\n\nBy submitting an application, the applicant agrees to all official Terms and Conditions of the scholarship. The applicant also grants Sevens Legal Criminal Lawyers permission to use their name, likeness, and submitted materials in promotional content, unless prohibited by law. Selected recipients are responsible for keeping Sevens Legal Criminal Lawyers informed of any changes to their contact information during the scholarship period\n\n**Right to Modify or Cancel**\n\nSevens Legal Criminal Lawyers reserves the right to cancel, suspend, or modify the scholarship or these terms in the event of force majeure or other circumstances beyond its control. Any changes will be posted on the official scholarship webpage.\n\n**Third-Party Responsibility Disclaimer**\n\nSevens Legal Criminal Lawyers is not responsible for inaccurate prize details provided by third parties connected to this promotion.\n\n**Governing Law and Jurisdiction**\n\nThis promotion is governed by the laws of the State of California. Any disputes will be subject to the exclusive jurisdiction of the courts located in the State of California.\n\n**Social Media Disclaimer**\n\nThis promotion is in no way sponsored, endorsed, or administered by, or associated with, Facebook, Twitter, Instagram, or any other platform. Information provided is solely for use by Sevens Legal Criminal Lawyers and will be handled according to our Privacy Policy."
		}
	},
	"Features 04": {
		"action": {
			"permission": "Admin",
			"translations": {
				"en": "Email Jessica!"
			},
			"type": "TextInput",
			"value": "Email Jessica!"
		},
		"actionHref": {
			"permission": "Admin",
			"translations": {
				"en": "mailto:jessica@sevenslegal.com"
			},
			"type": "TextInput",
			"value": "mailto:jessica@sevenslegal.com"
		},
		"description": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": "### We’re here to help.\n\nReach out to jessica@sevenslegal.com with any scholarship inquiries.\n"
		},
		"index": 5,
		"title": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "Questions?"
		}
	},
	"Form Apply Now": {
		"Question 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Please enter your full name"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your Name"
				},
				"label": {
					"translations": {},
					"value": "Name"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Email Address must be valid \".edu\" required for college applicants"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter a valid email address"
				},
				"label": {
					"translations": {},
					"value": "Email Address"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "email"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Please enter a phone number you can be reached at"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please Enter a valid phone number"
				},
				"label": {
					"translations": {},
					"value": "Phone"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "phone"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Please enter your full mailing address below"
				},
				"label": {
					"translations": {},
					"value": "Mailing Address"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "textarea"
				}
			}
		},
		"Question 04a": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Mailing Address"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your Street Address"
				},
				"label": {
					"translations": {},
					"value": "Street Address"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04b": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"label": {
					"translations": {},
					"value": "Street Address Line 2"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04c": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your City"
				},
				"label": {
					"translations": {},
					"value": "City"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04d": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your State / Province"
				},
				"label": {
					"translations": {},
					"value": "State / Province"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 04e": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your Postal / Zip Code"
				},
				"label": {
					"translations": {},
					"value": "Postal / Zip Code"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter you date of birth"
				},
				"label": {
					"translations": {},
					"value": "Date of Birth"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "date"
				}
			}
		},
		"Question 11": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Please choose from one of the scholarships listed"
				},
				"invalidMessage": {
					"translations": {},
					"value": "You must choose one of the listed scholarships"
				},
				"label": {
					"translations": {},
					"value": "Scholarship Selection"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "High School Scholarship+||+College / Junior College / Graduate Scholarship"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "radio"
				}
			}
		},
		"Question 12": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "What Current School are you attending?"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your current school name"
				},
				"label": {
					"translations": {},
					"value": "Current School"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 13": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "What is your current student status or year?"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please select your current grade level or year"
				},
				"label": {
					"translations": {},
					"value": "Student Status / Year"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "High School Senior+||+College Freshman+||+College Sophomore+||+College Junior+||+College Senior accepted/enrolled in graduate school+||+Graduate Student - Not in final year"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "radio"
				}
			}
		},
		"Question 14": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "What is your current cumulative GPA?"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please enter your current cumulative GPA"
				},
				"label": {
					"translations": {},
					"value": "Cumulative GPA"
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"type": {
					"translations": {},
					"value": "text"
				}
			}
		},
		"Question 15": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "image/*+||+application/pdf"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Transcript (file upload — PDF or image of official/unofficial transcript)"
				},
				"invalidMessage": {
					"translations": {},
					"value": "Please drop your transcript file or files here"
				},
				"label": {
					"translations": {},
					"value": "Transcript Uploads"
				},
				"requiredCount": {
					"translations": {},
					"value": "1"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Question 21": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "application/pdf+||+application/msword+||+application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### High School Essay Prompt\n**\"As criminal lawyers, we know initial impressions rarely tell the whole story. Describe a time when you rushed to judgment about a person or a situation, only to realize later that you were completely wrong. What caused your perspective to shift, and how has that changed how you approach others?\"**\n\nYour essay must be:\n - A minimum of 1,000 words\n - Original, clearly written, and well-organized\n - Thoughtful, creative, and grammatically sound\n\nEssays will be scored based on clarity, depth, organization, and connection to the theme.\n\nYou can upload your essay by dropping it below or submit it at a later time (file upload — PDF or Word)"
				},
				"hideInForm": {
					"translations": {},
					"value": "Scholarship Selection+|+not-in+|+High School Scholarship"
				},
				"label": {
					"translations": {},
					"value": "High School Essay Upload"
				},
				"limit": {
					"translations": {},
					"value": "1"
				},
				"requiredCount": {
					"translations": {},
					"value": "0"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Question 22": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "application/pdf+||+application/msword+||+application/vnd.openxmlformats-officedocument.wordprocessingml.document"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### College Essay Prompt\n**“The Sixth Amendment guarantees the right to counsel to every accused individual, yet criminal defense attorneys often face intense scrutiny when representing individuals the public has already deemed guilty. Analyze the moral and ethical dynamics a defense attorney and advocate must navigate when defending an unpopular client. Furthermore, critically evaluate the foundational purpose of the Sixth Amendment. Address why a fair society should view a passionate defense not as a loophole for the accused, but as a shield to protect the constitutional rights of the entire public.”**\n\nYour essay must be:\n - A minimum of 1,000 words\n - Original, clearly written, and well-organized\n - Thoughtful, creative, and grammatically sound\n\nEssays will be scored based on clarity, depth, organization, and connection to the theme.\n\nYou can upload your essay by dropping it below or submit it at a later time (file upload — PDF or Word)"
				},
				"hideInForm": {
					"translations": {},
					"value": "Scholarship Selection+|+not-in+|+College / Junior College / Graduate Scholarship"
				},
				"label": {
					"translations": {},
					"value": "College Essay Upload"
				},
				"requiredCount": {
					"translations": {},
					"value": "0"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Question 41": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### Please confirm you meet the following eligibility requirements for your selected scholarship."
				},
				"invalidMessage": {
					"translations": {},
					"value": "You must confirm you meet the requirements by checking each box"
				},
				"label": {
					"translations": {},
					"value": "Eligibility Checklist"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "I am a U.S. citizen or lawful permanent resident.+||+I meet the GPA requirement (3.0 or higher).+||+I am enrolled full-time in high school (senior year) OR in college (freshman–junior).+||+I am not an employee of Sevens Legal Criminal Lawyers, nor an immediate family/household member of one."
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"requiredCount": {
					"translations": {},
					"value": "4"
				},
				"type": {
					"translations": {},
					"value": "checkbox"
				}
			}
		},
		"Question 42": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### Please agree to the following terms listed below."
				},
				"invalidMessage": {
					"translations": {},
					"value": "You must agree to the terms listed by checking each box"
				},
				"label": {
					"translations": {},
					"value": "Consent & Agreement"
				},
				"optionLabelPos": {
					"translations": {},
					"value": "right"
				},
				"optionLayout": {
					"translations": {},
					"value": "vertical"
				},
				"options": {
					"translations": {},
					"value": "I agree to the Terms & Legal Disclosures of the scholarship program.+||+I grant Sevens Legal Criminal Lawyers permission to use my name, likeness, and submitted materials in promotional content if selected.+||+I acknowledge that the information I’ve provided is true and accurate to the best of my knowledge."
				},
				"required": {
					"translations": {},
					"value": "true"
				},
				"requiredCount": {
					"translations": {},
					"value": "3"
				},
				"type": {
					"translations": {},
					"value": "checkbox"
				}
			}
		},
		"Question 43": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"accept": {
					"translations": {},
					"value": "image/*"
				},
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "### Profile Photo Upload (Optional)\nIf you wish at this time, you may upload a photo of yourself."
				},
				"label": {
					"translations": {},
					"value": "Photo Upload"
				},
				"requiredCount": {
					"translations": {},
					"value": "0"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"Section 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Please provide your personal contact details so we can reach you if needed. This includes your full name, email address, phone number, mailing address, and date of birth."
				},
				"label": {
					"translations": {},
					"value": "Applicant Information"
				},
				"questions": {
					"translations": {},
					"value": "Question 01+||+Question 02+||+Question 03+||+Question 04a+||+Question 04b+||+Question 04c+||+Question 04d+||+Question 04e+||+Question 05"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"Section 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Tell us about your academic background. Select the scholarship you’re applying for, share your current school, grade level or year, GPA, and (optionally) upload your transcript.\n\n<br />\n\n*Don’t worry if you don’t have your transcript ready — you can still apply today.*"
				},
				"label": {
					"translations": {},
					"value": "Academic Information"
				},
				"questions": {
					"translations": {},
					"value": "Question 11+||+Question 12+||+Question 13+||+Question 14+||+Question 15"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"Section 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Every scholarship includes an essay prompt. We’d love to see your essay now, but you can also apply without it and submit later."
				},
				"label": {
					"translations": {},
					"value": "Essay Submission"
				},
				"questions": {
					"translations": {},
					"value": "Question 21+||+Question 22"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"Section 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"heading": {
					"translations": {},
					"value": "Before submitting, please confirm that you meet the eligibility criteria and agree to the terms of this scholarship program. You may also upload an optional photo if you’d like to include one."
				},
				"label": {
					"translations": {},
					"value": "Eligibility, Consent & Agreement"
				},
				"questions": {
					"translations": {},
					"value": "Question 41+||+Question 42+||+Question 43"
				},
				"type": {
					"translations": {},
					"value": "section"
				}
			}
		},
		"general": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"confirmationMessage": {
					"translations": {},
					"value": "### Thank you for your application!  It has been submitted successfully.\n\n<br />\n\n*If you are using a public computer, use the reset button to the right to clear you data from the browser*"
				},
				"formName": {
					"translations": {},
					"value": "Scholarship"
				},
				"id": {
					"translations": {},
					"value": "apply-now-form"
				},
				"title": {
					"translations": {},
					"value": "Scholarship Application"
				}
			}
		},
		"index": 6,
		"order": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "9"
		}
	},
	"FormSubmission 01": {
		"Question 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"en": "Full Name"
					},
					"value": "Full Name"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please enter your Name"
					},
					"value": "Please enter your Name"
				},
				"label": {
					"translations": {
						"en": "Name"
					},
					"value": "Name"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "1"
					},
					"value": "1"
				},
				"heading": {
					"translations": {
						"en": "Email Address"
					},
					"value": "Email Address"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please enter a valid email address"
					},
					"value": "Please enter a valid email address"
				},
				"label": {
					"translations": {
						"en": "Email Address"
					},
					"value": "Email Address"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "email"
					},
					"value": "email"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "1"
					},
					"value": "1"
				},
				"heading": {
					"translations": {
						"en": "Phone Number"
					},
					"value": "Phone Number"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please Enter a valid phone number"
					},
					"value": "Please Enter a valid phone number"
				},
				"label": {
					"translations": {
						"en": "Phone Number"
					},
					"value": "Phone Number"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "tel"
					},
					"value": "tel"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"en": "Mailing Address"
					},
					"value": "Mailing Address"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please enter your Street Address"
					},
					"value": "Please enter your Street Address"
				},
				"label": {
					"translations": {
						"en": "Street Address"
					},
					"value": "Street Address"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"label": {
					"translations": {
						"en": "Street Address Line 2"
					},
					"value": "Street Address Line 2"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 06": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {
						"en": "Please enter your City"
					},
					"value": "Please enter your City"
				},
				"label": {
					"translations": {
						"en": "City"
					},
					"value": "City"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 07": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {
						"en": "Please enter your State / Province"
					},
					"value": "Please enter your State / Province"
				},
				"label": {
					"translations": {
						"en": "State / Province"
					},
					"value": "State / Province"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 08": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please enter your Postal / Zip Code"
					},
					"value": "Please enter your Postal / Zip Code"
				},
				"label": {
					"translations": {
						"en": "Postal / Zip Code"
					},
					"value": "Postal / Zip Code"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 09": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"en": "Date of Birth"
					},
					"value": "Date of Birth"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please enter you date of birth"
					},
					"value": "Please enter you date of birth"
				},
				"label": {
					"translations": {
						"en": "Date of Birth"
					},
					"value": "Date of Birth"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "date"
					},
					"value": "date"
				}
			}
		},
		"heading": {
			"permission": "Admin",
			"translations": {
				"en": "### Contact Us\n---\nFill out the form below and someone will reach out to you."
			},
			"type": "TextArea",
			"value": "### Contact Us\n---\nFill out the form below and someone will reach out to you."
		},
		"index": 7,
		"section": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"en": "Contact Information"
					},
					"value": "Contact Information"
				},
				"section": {
					"translations": {
						"en": "Contact Information"
					},
					"value": "Contact Information"
				}
			}
		}
	},
	"FormSubmission 02": {
		"Question 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please choose one of the listed scholarships"
					},
					"value": "Please choose one of the listed scholarships"
				},
				"label": {
					"translations": {
						"en": "Scholarship Selection"
					},
					"value": "Scholarship Selection"
				},
				"optionLabelPos": {
					"translations": {
						"en": "right"
					},
					"value": "right"
				},
				"options": {
					"translations": {
						"en": "High School Scholarship – $500, College / Junior College Scholarship – $1,000"
					},
					"value": "High School Scholarship – $500, College / Junior College Scholarship – $1,000"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "radio"
					},
					"value": "radio"
				}
			}
		},
		"Question 02": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"en": "Current School"
					},
					"value": "Current School"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please enter your current school name"
					},
					"value": "Please enter your current school name"
				},
				"label": {
					"translations": {
						"en": "Current School"
					},
					"value": "Current School"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 03": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {
						"en": "Please select your current grade level or year"
					},
					"value": "Please select your current grade level or year"
				},
				"label": {
					"translations": {
						"en": "Grade Level / Year"
					},
					"value": "Grade Level / Year"
				},
				"options": {
					"translations": {
						"en": "High School Senior, College Freshman, Sophomore, Junior"
					},
					"value": "High School Senior, College Freshman, Sophomore, Junior"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "dropdown"
					},
					"value": "dropdown"
				}
			}
		},
		"Question 04": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"invalidMessage": {
					"translations": {
						"en": "Please enter your current cumulative GPA"
					},
					"value": "Please enter your current cumulative GPA"
				},
				"label": {
					"translations": {
						"en": "Cumulative GPA"
					},
					"value": "Cumulative GPA"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "text"
					},
					"value": "text"
				}
			}
		},
		"Question 05": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {
						"en": "2"
					},
					"value": "2"
				},
				"heading": {
					"translations": {
						"en": "Transcript (file upload — PDF or image of official/unofficial transcript)"
					},
					"value": "Transcript (file upload — PDF or image of official/unofficial transcript)"
				},
				"invalidMessage": {
					"translations": {
						"en": "Please drop your transcript file or files here"
					},
					"value": "Please drop your transcript file or files here"
				},
				"label": {
					"translations": {
						"en": "Transcript Uploads"
					},
					"value": "Transcript Uploads"
				},
				"required": {
					"translations": {
						"en": "true"
					},
					"value": "true"
				},
				"type": {
					"translations": {
						"en": "file"
					},
					"value": "file"
				}
			}
		},
		"index": 8,
		"section": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"en": "Scholarship Information"
					},
					"value": "Scholarship Information"
				},
				"section": {
					"translations": {
						"en": "Scholarship Information"
					},
					"value": "Scholarship Information"
				}
			}
		}
	},
	"FormSubmission 03": {
		"Question 01": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"colSpan": {
					"translations": {},
					"value": "2"
				},
				"heading": {
					"translations": {},
					"value": "Upload Essay (file upload — PDF or Word)"
				},
				"label": {
					"translations": {},
					"value": "Essay Upload"
				},
				"type": {
					"translations": {},
					"value": "file"
				}
			}
		},
		"index": 9,
		"section": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"label": {
					"translations": {
						"en": "Essay Submission"
					},
					"value": "Essay Submission"
				},
				"section": {
					"translations": {
						"en": "Essay Submission"
					},
					"value": "Essay Submission"
				}
			}
		}
	},
	"PageBanner": {
		"action": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"href": {
					"translations": {
						"en": "/#apply-now-form"
					},
					"value": "/#apply-now-form"
				},
				"label": {
					"translations": {
						"en": "Apply Now"
					},
					"value": "Apply Now"
				}
			}
		},
		"bgImage": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "Graduation mortar board cap on one hundred dollar bills concept for the cost of a college and university education"
					},
					"value": "Graduation mortar board cap on one hundred dollar bills concept for the cost of a college and university education"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fscholarships%2FPageBanner%2FbgImage%2Foutput.jpg?alt=media&token=42acfc6d-e2a5-49f1-97d2-21f94a82bd70",
				"formattedSize": "4.00 MB",
				"height": 1755,
				"name": "output.jpg",
				"path": "uploads/scholarships/PageBanner/bgImage/output.jpg",
				"query": "?as=run",
				"size": 4189179,
				"type": "image/jpeg",
				"updated": "2025-09-04T20:17:59.977Z",
				"width": 5616
			}
		},
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"actionClass": {
					"translations": {},
					"value": "hover-ripple btn btn-sm sm:btn-xl mt-2 sm:mt-4 shadow-lg whitespace-nowrap btn-outline"
				},
				"bgImageClass": {
					"translations": {},
					"value": "opacity-60"
				},
				"contentClass": {
					"translations": {},
					"value": "mx-2 sm:mx-4"
				}
			}
		},
		"index": 10,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "1"
			},
			"type": "TextInput",
			"value": "1"
		},
		"subtitle": {
			"permission": "Admin",
			"translations": {
				"en": "## Investing in the Promise of Tomorrow’s Leaders"
			},
			"type": "TextInput",
			"value": "## Investing in the Promise of Tomorrow’s Leaders"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en": "Sevens Legal Criminal Lawyers Scholarship"
			},
			"type": "TextArea",
			"value": "Sevens Legal Criminal Lawyers Scholarship"
		}
	},
	"SideBySide 01": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "px-2 sm:px-4"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": " - ### First Place Award: $750\n - ### Runner-Up Award: $250\nFunds must be applied toward qualified educational expenses, such as:\n - Tuition and fees\n - Books and supplies\n - On-campus housing\n\nFunds are provided by Sevens Legal Criminal Lawyers and will be disbursed directly to the winning student upon verification of enrollment and academic standing.\n\n### Essay Prompt\n**\"As criminal lawyers, we know initial impressions rarely tell the whole story. Describe a time when you rushed to judgment about a person or a situation, only to realize later that you were completely wrong. What caused your perspective to shift, and how has that changed how you approach others?\"**\n\nYour essay must be:\n- A minimum of 1,000 words\n - Original, clearly written, and well-organized\n - Thoughtful, creative, and grammatically sound\n\nEssays will be scored based on clarity, depth, organization, and connection to the theme.\n\n### Eligibility Requirements\nTo qualify, applicants must:\n - Be a U.S. citizen or lawful permanent resident\n - Be enrolled full-time as a senior in a U.S. high school at the time of entry\n - Have a minimum cumulative GPA of 3.0 (verified by transcript)\n - Submit a 1,000-word essay responding to the prompt\n\n**Note:** Employees of Sevens Legal Criminal Lawyers and their immediate family or household members are not eligible to apply."
		},
		"flipped": {
			"permission": "Admin",
			"translations": {
				"en": "true"
			},
			"type": "TextInput",
			"value": "true"
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "Happy young students taking a vertical selfie portrait together at university library. African american guy shooting a photo with his smiley classmates on a high school meeting. Friends at academy"
					},
					"value": "Happy young students taking a vertical selfie portrait together at university library. African american guy shooting a photo with his smiley classmates on a high school meeting. Friends at academy"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fscholarships%2FSideBySide%2001%2Fimage%2Fshutterstock_2430940381.jpg?alt=media&token=c33ca994-3582-4faa-a52c-1374bb1e48b5",
				"formattedSize": "16.02 MB",
				"height": 7008,
				"name": "shutterstock_2430940381.jpg",
				"path": "uploads/scholarships/SideBySide 01/image/shutterstock_2430940381.jpg",
				"query": "?as=run",
				"size": 16800600,
				"type": "image/jpeg",
				"updated": "2025-09-04T19:37:04.223Z",
				"width": 4672
			}
		},
		"index": 11,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "3"
			},
			"type": "TextInput",
			"value": "3"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en": "High School Scholarship"
			},
			"type": "TextInput",
			"value": "High School Scholarship"
		}
	},
	"SideBySide 02": {
		"classes": {
			"permission": "Admin",
			"type": "TextObject",
			"value": {
				"contentClass": {
					"translations": {},
					"value": "px-2 sm:px-4 py-0 sm:py-24"
				}
			}
		},
		"description": {
			"permission": "Admin",
			"translations": {},
			"type": "TextArea",
			"value": " - ### First Place Award: $1,000\n - ### Runner-Up Award: $500\nFunds must be applied toward qualified educational expenses, such as:\n - Tuition and fees\n - Books and supplies\n - On-campus housing or meal plans\n\nFunds are provided by Sevens Legal Criminal Lawyers and will be disbursed directly to the winning student upon verification of enrollment and academic standing.\n\n### Essay Prompt\n**“The Sixth Amendment guarantees the right to counsel to every accused individual, yet criminal defense attorneys often face intense scrutiny when representing individuals the public has already deemed guilty. Analyze the moral and ethical dynamics a defense attorney and advocate must navigate when defending an unpopular client. Furthermore, critically evaluate the foundational purpose of the Sixth Amendment. Address why a fair society should view a passionate defense not as a loophole for the accused, but as a shield to protect the constitutional rights of the entire public.”**\n\nYour essay must be:\n - A minimum of 1,000 words\n - Original, clearly written, and well-organized\n - Thoughtful, creative, and grammatically sound\n\nEssays will be scored based on clarity, depth, organization, and connection to the theme.\n\n### Eligibility Requirements\nTo qualify, applicants must:\n - Be a U.S. citizen or lawful permanent resident\n - Be at least 18 years old at the time of application\n - Be enrolled full-time at an accredited U.S. junior college, college, or university as either:\n   - An undergraduate freshman, sophomore, or junior; or\n   - A college senior who is enrolled in or accepted to graduate school for the upcoming academic year; or\n   - A graduate student who is not in their final year of study\n - Have a minimum cumulative GPA of 3.0 (verified by transcript)\n - Submit a 1,000-word essay responding to the prompt\n\n**Note:** Recipients must maintain a GPA of 3.0 or higher during the scholarship period. Employees of Sevens Legal Criminal Lawyers and their immediate family or household members are not eligible to apply."
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "Yale university buildings in spring blue sky in New Haven, CT USA"
					},
					"value": "Yale university buildings in spring blue sky in New Haven, CT USA"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fscholarships%2FSideBySide%2002%2Fimage%2Fshutterstock_278796914.jpg?alt=media&token=8b1e5d8c-6197-447f-84c7-b917b9bdaafd",
				"formattedSize": "13.15 MB",
				"height": 4500,
				"name": "shutterstock_278796914.jpg",
				"path": "uploads/scholarships/SideBySide 02/image/shutterstock_278796914.jpg",
				"query": "?as=run",
				"size": 13791930,
				"type": "image/jpeg",
				"updated": "2025-09-04T19:29:18.186Z",
				"width": 3000
			}
		},
		"index": 12,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "4"
			},
			"type": "TextInput",
			"value": "4"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en": "College & Junior College Scholarship"
			},
			"type": "TextInput",
			"value": "College & Junior College Scholarship"
		}
	},
	"SideBySide 03": {
		"description": {
			"permission": "Admin",
			"translations": {
				"en": "If selected, you will be asked to:\n - Submit a completed IRS W-9 form\n - Provide proof of enrollment and GPA verification\n - Optionally provide a brief testimonial, photograph, or statement for use in promotional materials\n\n*Failure to submit the required documentation may result in a delay or forfeiture of the scholarship award.*\n"
			},
			"type": "TextArea",
			"value": "If selected, you will be asked to:\n - Submit a completed IRS W-9 form\n - Provide proof of enrollment and GPA verification\n - Optionally provide a brief testimonial, photograph, or statement for use in promotional materials\n\n*Failure to submit the required documentation may result in a delay or forfeiture of the scholarship award.*\n"
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "Walking, happy and girl with friends at university for learning, bonding and talking with fun. People, school and group of gen z students commuting outdoor ready for education at college campus."
					},
					"value": "Walking, happy and girl with friends at university for learning, bonding and talking with fun. People, school and group of gen z students commuting outdoor ready for education at college campus."
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fscholarships%2FSideBySide%2003%2Fimage%2Fshutterstock_2477767447.jpg?alt=media&token=4085b6ff-8e52-4e80-a89e-197c36ff10f4",
				"formattedSize": "3.05 MB",
				"height": 2160,
				"name": "shutterstock_2477767447.jpg",
				"path": "uploads/scholarships/SideBySide 03/image/shutterstock_2477767447.jpg",
				"query": "?as=run",
				"size": 3200269,
				"type": "image/jpeg",
				"updated": "2025-09-05T00:36:33.924Z",
				"width": 4096
			}
		},
		"index": 13,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "6"
			},
			"type": "TextInput",
			"value": "6"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en": "After You Win"
			},
			"type": "TextInput",
			"value": "After You Win"
		}
	},
	"SideBySide 04": {
		"bgAltBase": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "false"
		},
		"description": {
			"permission": "Admin",
			"translations": {
				"en": "At Sevens Legal Criminal Lawyers, we understand how education can open doors and shape futures. As one of San Diego’s premier criminal defense firms—with over 150 years of combined legal experience—our mission is rooted in advocacy, accountability, and helping people move forward with purpose.\n\nLed by Certified Criminal Law Specialist Samantha Greene, Firm Director Kerry Steigerwalt, and Managing Partner Dan Greene, our team has earned a reputation for delivering exceptional results and personalized support. In 2024, we were proud to be voted Best Criminal Defense Firm and Best DUI Firm in San Diego—recognition that reflects our commitment not just to legal excellence, but to the people and communities we serve.\n\nThrough this scholarship, we’re honored to support students like you—motivated individuals who are committed to growth, learning, and making a meaningful impact. No matter your field of study, if you bring integrity, focus, and a desire to contribute to something greater, we believe in your journey—and we’re proud to help you take the next step.\n"
			},
			"type": "TextArea",
			"value": "At Sevens Legal Criminal Lawyers, we understand how education can open doors and shape futures. As one of San Diego’s premier criminal defense firms—with over 150 years of combined legal experience—our mission is rooted in advocacy, accountability, and helping people move forward with purpose.\n\nLed by Certified Criminal Law Specialist Samantha Greene, Firm Director Kerry Steigerwalt, and Managing Partner Dan Greene, our team has earned a reputation for delivering exceptional results and personalized support. In 2024, we were proud to be voted Best Criminal Defense Firm and Best DUI Firm in San Diego—recognition that reflects our commitment not just to legal excellence, but to the people and communities we serve.\n\nThrough this scholarship, we’re honored to support students like you—motivated individuals who are committed to growth, learning, and making a meaningful impact. No matter your field of study, if you bring integrity, focus, and a desire to contribute to something greater, we believe in your journey—and we’re proud to help you take the next step.\n"
		},
		"flipped": {
			"permission": "Admin",
			"translations": {},
			"type": "TextInput",
			"value": "true"
		},
		"image": {
			"permission": "Admin",
			"type": "Image",
			"value": {
				"description": {
					"translations": {
						"en": "Group photo of the Sevens Legal law firm"
					},
					"value": "Group photo of the Sevens Legal law firm"
				},
				"downloadUrl": "https://firebasestorage.googleapis.com/v0/b/sevens-legal.firebasestorage.app/o/uploads%2Fscholarships%2FSideBySide%2004%2Fimage%2FAttorney%20Group%20Photo.jpeg?alt=media&token=d2d733db-4b0f-4d04-8b48-4857b0d2648b",
				"formattedSize": "743.77 KB",
				"height": 1427,
				"name": "Attorney Group Photo.jpeg",
				"path": "uploads/scholarships/SideBySide 04/image/Attorney Group Photo.jpeg",
				"query": "?as=run",
				"size": 761618,
				"type": "image/jpeg",
				"updated": "2025-09-05T01:14:39.672Z",
				"width": 2336
			}
		},
		"index": 14,
		"order": {
			"permission": "Admin",
			"translations": {
				"en": "8"
			},
			"type": "TextInput",
			"value": "8"
		},
		"title": {
			"permission": "Admin",
			"translations": {
				"en": "About Sevens Legal Criminal Lawyers"
			},
			"type": "TextInput",
			"value": "About Sevens Legal Criminal Lawyers"
		}
	}
}